import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

const PersonList = Loadable(lazy(() => import("pages/person")));
const CreatePerson = Loadable(lazy(() => import("pages/person/Create")));
const UpdatePerson = Loadable(lazy(() => import("pages/person/Update")));

const PersonRoutes = {
  path: "person",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <PersonList />,
    },
    {
      path: "create",
      element: <CreatePerson />,
    },
    {
      path: "update/:personId",
      element: <UpdatePerson />,
    },
  ],
};

export default PersonRoutes;
